import { Form, Input } from 'antd'

import { TaskFormElement } from './types'

type Props = {
  element: TaskFormElement
  required?: boolean
}

export const InputElement = ({ element, required }: Props) => {
  return (
    <Form.Item name={element.name} label={element.label} rules={[{ required }]}>
      <Input />
    </Form.Item>
  )
}
